import React from "react";
import {BooleanRadioButton, BooleanRadioButtonGroup} from "@octopusdeploy/design-system-components";
import {DataBaseComponent, DataBaseComponentState, Errors} from "components/DataBaseComponent";
import repository from "client/repository";
import {BusyState} from "components/BusyFromPromise/BusyFromPromise";
import {HostedInstanceResource} from "client/resources/hostedInstanceResource";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import Select from "components/form/Select/Select";
import {HostedInstanceConfigureHostingTaskLimitRequest} from "client/resources/HostedInstanceConfigureHostingTaskLimitRequest";
import {HostedInstanceHostingTaskLimitValues} from "shared/hostingTaskLimitValues";
import {InstanceLimitResource} from "client/resources/instanceLimitResource";
import {ManualScalingCallout} from "./ManualScalingCallouts";

interface ConfigureHostingTaskLimitDialogProps {
    errors: Errors;
    busy: BusyState;
    instance: HostedInstanceResource;
    instanceLimit: InstanceLimitResource;
    onSaveClick(): Promise<boolean>;
}

interface ConfigureHostingTaskLimitDialogState extends DataBaseComponentState {
    request: HostedInstanceConfigureHostingTaskLimitRequest;
}

export class ConfigureHostingTaskLimitDialog extends DataBaseComponent<ConfigureHostingTaskLimitDialogProps, ConfigureHostingTaskLimitDialogState> {
    constructor(props: ConfigureHostingTaskLimitDialogProps) {
        super(props);
        this.state = {
            request: {
                HostingTaskLimit: this.props.instanceLimit.HostingTaskLimit,
                ReprovisionDuringMaintenanceWindow: true
            }
        };
    }

    render() {
        const request = this.state.request;
        return <SaveDialogLayout title={"Change Hosting Task Limit"}
                                 busy={this.state.busy}
                                 errors={this.state.errors}
                                 saveButtonDisabled={request.HostingTaskLimit === this.props.instanceLimit.HostingTaskLimit}
                                 onSaveClick={() => this.configureHostingTaskLimit(request)}>

            <ManualScalingCallout />

            <BooleanRadioButtonGroup value={request.ReprovisionDuringMaintenanceWindow}
                                     onChange={ReprovisionDuringMaintenanceWindow => this.updateRequest({ReprovisionDuringMaintenanceWindow})}>
                <BooleanRadioButton value={true} label="Apply During Maintenance Window" />
                <BooleanRadioButton value={false} label="Apply Immediately" />
            </BooleanRadioButtonGroup>

            <Select label="Hosting Task Limit"
                    value={`${request.HostingTaskLimit}`}
                    onChange={hostingTaskLimit => this.updateRequest({HostingTaskLimit: Number(hostingTaskLimit)})}
                    items={HostedInstanceHostingTaskLimitValues.map(value => ({value: `${value}`, text: `${value}`}))}
                    fieldName="HostingTaskLimit"
                    hintText="The number of tasks this instance is provisioned to run concurrently" />

        </SaveDialogLayout>;
    }

    private updateRequest(update: Partial<HostedInstanceConfigureHostingTaskLimitRequest>) {
        return this.setState(prevState => ({request: {...prevState.request, ...update}}));
    }

    private configureHostingTaskLimit(request: HostedInstanceConfigureHostingTaskLimitRequest) {
        return this.doBusyTask(async () => {
            await repository.HostedInstances.configureHostingTaskLimit(this.props.instance, request);
            await this.props.onSaveClick();
            return true;
        });
    }
}
